/*
  IMPORTANT: this file cannot reference any modules that are related to react & redux
  this is because service-worker runs under a different scope and cannot use those modules
*/

import { CERTA_API_URL } from 'config';
import { get, post2 } from './fetch';
import * as tokenService from 'services/token-service';
// import { convertMsStringToSeconds } from 'helpers/date-helper';
import { OperationItem } from 'types/operation-item';
// import { SinglePackResponse } from 'types/api/single-pack-response';
import { SinglePackRequest } from 'types/api/single-pack-request';
// import { NmvsResponse } from 'types/api/nmvs-response';

export async function getCodeStatus (item: OperationItem) {
  return await performSinglePack('/verify', item);
}

export async function dispense (item: OperationItem) {
  return await performSinglePack('/dispense', item);
}

export async function sample (item: OperationItem) {
  return await performSinglePack('/singlePack/sample', item);
}

export async function undoDispense (item: OperationItem) {
  return await performSinglePack('/singlePack/undoDispense', item);
}

export async function undoSample (item: OperationItem) {
  return await performSinglePack('/singlePack/undoSample', item);
}

export async function destroy (item: OperationItem) {
  return await performSinglePack('/destroy', item);
}

export async function performSinglePack(url: string, item: OperationItem) {
  const request: SinglePackRequest = {
    
    clientTransactionId: item.clientTransactionId,
    epc: item.epc,
    geot: item.geot,
    sessionToken: item.sessionToken
  };
  const response = await performQuery2<SinglePackRequest>(
    url,
    request,
    tokenService.JWT_BACKGROUND_TOKEN
  );
  // let result = response.body;
  // item.nmvsResponseTime = getResponseTimeHeader(response.headers, NmvsResponseTime);
  // item.optelResponseTime = getResponseTimeHeader(response.headers, OptelResponseTime) - item.nmvsResponseTime;
  return response;
}

export async function performQuery<TRequest, TResponse>
  (url: string, request: TRequest, tokenId: string): Promise<TResponse> {
  // const token = await tokenService.readToken(tokenId);
  // const language = await tenantService.getLanguageCode();
  const result = await get<TResponse>(
    CERTA_API_URL + url
    // request
    // token,
    // undefined
    // language
  );
  return result;
}

export async function performQuery2<TRequest>
  (url: string, request: TRequest, tokenId: string) {
  // const token = await tokenService.readToken(tokenId);
  // const language = await tenantService.getLanguageCode();
  const result = await post2(
    CERTA_API_URL + url,
    // tslint:disable-next-line: no-string-literal
    request
    // token,
    // undefined
    // language
  );
  return result;
}

// NOTE: headers will come back as null when debugging locally because of the CORS policy on the server
// however when UI is ran from same site as API (when its deployed) it will work as expected
// https://developers.google.com/web/updates/2015/03/introduction-to-fetch#response_types
// function getResponseTimeHeader(headers: Headers, key: string): number {
//   const headerValue = headers.get(key);
//   return convertMsStringToSeconds(headerValue);
// }


// WEBPACK FOOTER //
// ./src/api/nmvs-api.ts